import "./Select.scss";
import {
  MotifSelect,
  MotifOption,
  MotifFormField,
  MotifErrorMessage,
} from "../../../assets/lib/motif";

export function Select({
  onChange,
  value = undefined,
  id = crypto.randomUUID(),
  className,
  required = false,
  disabled = false,
  placeholder = "",
  options = [],
  multiple = false,
  visibleOptions = 3,
  isError,
  errorMessage,
  disableErrorPlaceholder = true,
  showSelectAllButton = false,
  ...other
}) {
  const hasOnlyBlankSelected = Array.isArray(value) 
    ? value.length === 1 && value[0] === "(blank)"
    : value === "(blank)";

  return (
    <MotifFormField className={`decarb-select${hasOnlyBlankSelected ? " has-blank-selected" : ""}`}>
      <MotifSelect
        {...other}
        id={id}
        onChange={onChange}
        value={multiple ? value : value?.toString()}
        className={` ${className}`}
        required={required}
        disabled={disabled}
        multiple={multiple}
        visibleOptions={visibleOptions}
        showSelectAllButton={showSelectAllButton}
        placeholder={placeholder}
        filter
        triggerButtonProps={{
          "aria-describedby": id + "-error-message",
        }}
      >
        {options &&
          options.map((option) => {
            const optionValue = option?.id ? option.id.toString() : option;
            const optionLabel = option?.name ? option.name : option;
            const isBlank = optionLabel === "(blank)";
            return (
              <MotifOption
                key={crypto.randomUUID()}
                value={optionValue}
                selected={option?.selected ?? false}
                className={isBlank ? "blank-option" : ""}
              >
                {optionLabel}
              </MotifOption>
            );
          })}
      </MotifSelect>
      {isError ? (
        <MotifErrorMessage
          className="decarb-input-error-message"
          id={id + "-error-message"}
        >
          {errorMessage}
        </MotifErrorMessage>
      ) : !disableErrorPlaceholder ? (
        <div className="decarb-input-hide-error">No Error</div>
      ) : (
        <></>
      )}
    </MotifFormField>
  );
}
